export const SMART_TOOLTIP = {
  // SmartTooltip.tsx
  TOOLTIP_CONTAINER: 'smart-tooltip-container',
  TOOLTIP_CONTENT: 'smart-tooltip-content',
  TOOLTIP_VALUE_TEXT: 'smart-tooltip-value-text',
  TOOLTIP_VALUE_DURATION: 'smart-tooltip-value-duration',

  // SmartTooltipWithRef.tsx
  TOOLTIP_WITH_REF_CONTAINER: 'smart-tooltip-with-ref-container'
} as const;
